import React, { HTMLAttributes, ReactNode } from 'react'
import Tippy, { TippyProps } from '@tippyjs/react'
import 'tippy.js/animations/scale.css'
import { rounaDisplay, rounaMono, rouna } from 'utils/fonts'

type TooltipProps = {
  content: ReactNode
  placement?: TippyProps['placement']
  className?: string
  children?: ReactNode
  delay?: number
  show?: boolean
  maxWidth?: string
  wrapperClassName?: string
}

const Tooltip = ({
  children,
  content,
  className = '',
  placement = 'top',
  delay = 0,
  show = true,
  maxWidth = '20rem',
  wrapperClassName = '',
}: TooltipProps) => {
  if (show) {
    return (
      <Tippy
        animation="scale"
        placement={placement}
        appendTo={() => document.body}
        maxWidth={maxWidth}
        interactive
        delay={[delay, 0]}
        content={
          content ? (
            <div
              className={`${rounaDisplay.variable} ${rouna.variable} ${rounaMono.variable} rounded-md bg-th-bkg-2 px-3 py-2 font-body text-xs leading-4 text-th-fgd-3 outline-none focus:outline-none ${className}`}
              style={{ boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.5)' }}
            >
              {content}
            </div>
          ) : null
        }
      >
        <span className={`outline-none focus:outline-none ${wrapperClassName}`}>
          {children}
        </span>
      </Tippy>
    )
  } else {
    return <>{children}</>
  }
}

const Content = ({
  className = '',
  children,
}: {
  className?: string
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={`border-th-fgd-3/20 inline-block cursor-help border-b border-dashed hover:border-th-bkg-2 ${className}`}
    >
      {children}
    </div>
  )
}

Tooltip.Content = Content

export default Tooltip
